export const defaultCreateOptionHandler = (label) => ({
  label,
  value: label,
});
